/* eslint-disable operator-linebreak */
import { createAction } from '@reduxjs/toolkit';
import { UserPortofolioDetailListInterface } from 'app/interfaces/lender/UserPortofolioDetailInterface';
import { IPagination } from '../reducers/PortofolioReducer';
import { UserPortofolioListItem } from '../reducers/UserPortofolioReducer';

export const GET_USER_PORTOFOLIO_LIST = 'GET_USER_PORTOFOLIO_LIST';
export const SET_USER_PORTOFOLIO_LIST = 'SET_USER_PORTOFOLIO_LIST';
export const GET_USER_DETAIL_PORTOFOLIO_LIST =
	'GET_USER_DETAIL_PORTOFOLIO_LIST';
export const SET_USER_DETAIL_PORTOFOLIO_LIST =
	'SET_USER_DETAIL_PORTOFOLIO_LIST';
export const SUCCESS_SET_USER_PORTOFOLIO_LIST =
	'SUCCESS_SET_USER_PORTOFOLIO_LIST';

export interface IUserPortofolioParamsRequest {
	name: string;
}

export interface IUserPortofolioDetailRequestInterface {
	borrowerId: string;
	page: number;
	limit: number;
}

export interface IUserPortofolioParamsResponse {
	userPortofolioList: UserPortofolioListItem[];
	pagination: IPagination;
}

export interface IUserPortofolioDetailInterface {
	detailList: UserPortofolioDetailListInterface[];
	borrowerId: string;
	pagination: IPagination;
}

export const getUserPortofolioListAction =
	createAction<IUserPortofolioParamsRequest>(GET_USER_PORTOFOLIO_LIST);
export const setUserPortofolioListAction =
	createAction<IUserPortofolioParamsResponse>(SET_USER_PORTOFOLIO_LIST);
export const getUserPortofolioDetailAction =
	createAction<IUserPortofolioDetailRequestInterface>(
		GET_USER_DETAIL_PORTOFOLIO_LIST
	);
export const setUserPortofolioDetailAction =
	createAction<IUserPortofolioDetailInterface>(
		SET_USER_DETAIL_PORTOFOLIO_LIST
	);
